<template>
  <div class="w-100 d-flex bg-white " style="min-height: 200px">
    <div class="container-box mx-auto">

      <div class="card-box">
        <div class="card card-box-item" v-for="item in articleList">
          <b-link :to="'/articleDetail/'+item.id">
            <div class="card-head-img">
              <b-link :to="'/articleDetail/'+item.id">
                <img :src="getFileAccessHttpUrl(item.coverImgUrl)" alt="">
              </b-link>
            </div>
            <div class="card-body">
              <div class="card-heade-title d-flex align-items-center">
                <b-nav-text class="text-active-color" style="font-size: 13px">{{ item.createTime }}</b-nav-text>
                <span class="desc-text">
                 <b-icon icon="eye"></b-icon> {{item.browse}}
                </span>
              </div>
              <a href="#">
                <div class="card-body-title box-overflow-hidden">{{item.title}}</div>
              </a>
              <p class="card-text desc-text two-line">{{item.articleDesc}}</p>
            </div>
          </b-link>
        </div>
      </div>

      <div class="pt-5 w-100">
        <b-pagination align="center"
            v-model="form.pageNo"
            :total-rows="form.total"
            :per-page="form.pageSize"
            @input="getArticleList"
        ></b-pagination>
      </div>

    </div>
  </div>
</template>

<script>
import {getAction, getFileAccessHttpUrl} from "@/api/manage";

export default {
  data(){
    return {
      articleList:[],
      form:{
        pageNo:1,
        total:0,
        pageSize:10,
        articleType:this.$route.params.type
      }
    }
  },
  created() {

  },
  mounted() {
    this.getArticleList();
  },
  watch:{
    '$route': {
      handler(newValue, oldValue) {
        if(newValue.params.type){
          this.form.articleType = newValue.params.type
          this.getArticleList()
        }
      },
    }
  },
  methods:{
    getFileAccessHttpUrl,
    getArticleList(){
      // let type = this.$route.type;
      getAction("/front/article/getArticleList.html",this.form).then(res => {
        this.articleList = res.result.records;
        this.form.currentPage = res.result.current;
        this.form.total = res.result.total;
      })
    }
  }
}
</script>
<style lang="scss">
.card-body-title{
  height: 30px;
  line-height: 30px;
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: 400;
  color: #242e3e;
}

.card-box-item:hover .card-body-title{
  color: var(--secondary-color);
  text-decoration: underline;
}
.desc-text{
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  color: #888E97;
  line-height: 23px;
}
.card-heade-title{
  justify-content: space-between;
}
.text-active-color{
  color: var(--secondary-color) !important;
  text-decoration: none !important;
}
.card-head-img{
  overflow: hidden;
  -webkit-transition: all .3s ease;
  transition: all .3s ease;
  width: 100%;
  height: 0;
  padding-top: 61.724%;
  position: relative;
  background: #fff;
  border-bottom: 1px solid rgba(0,0,0,.08);
}

.card-box{
  display: grid;
  grid-template-columns: calc(100%/3 - 13.66px) calc(100%/3 - 13.66px) calc(100%/3 - 13.66px);
  grid-gap: 30px;
}
.card-box-item{
  cursor: pointer;
}
.card-box-item img{
  //width: 100%; /* 图片宽度100%以适应容器 */
  width: 438px;
  height: 298px;
  //height: auto; /* 保持原始宽高比例 */
  transform: scale(1); /* 初始缩放为1，即正常大小 */
  transition: transform 0.3s; /* 添加平滑过渡效果 */
  -o-object-fit: cover;
  object-fit: cover;
  position: absolute;
  top: -27px;
  left: 0;
  opacity: 1;
}

.card-box-item:hover img{
  transform: scale(1.2); /* 放大图像到1.2倍大小 */
}
</style>